<script setup>
const props = defineProps({
  choice: Object,
})
</script>

<template>
  <div class="item">
    <span class="equal-small-2">
      {{ props.choice.title }}
    </span>
    <span class="equal-base equal-base--tighter">
      {{ props.choice.weight }}{{ props.choice.unit }}
    </span>
    <span
      v-if="props.choice.third"
      class="equal-base equal-base--tighter"
    >
      {{ props.choice.third }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.item {
  display: flex;
  flex-direction: column;
  padding: 20px;
  margin: auto;
}
</style>
